/*@flow*/
import * as I from 'immutable';
import useHistory from 'lib/useHistory';

function useBrowserQuery() {
  const loc = useHistory();
  return loc.query || {};
}

export default function useLayerQueries(): I.Map<string, any> {
  const query = useBrowserQuery();
  const deck = I.fromJS(query).getIn(['deck']);
  return I.Map({ deck });
}
